import * as React from 'react';
import type { SoftwareApplication, WithContext } from 'schema-dts';

import type { SanityIntegration } from '#/lib/sanity/queries/integration';

import { schemaOrganization } from './consts';
import { RenderSEOSchema } from './Render';

export function IntegrationSchema({
  title,
  description,
  href,
  imageUrl,
}: SanityIntegration) {
  // Omit Offer — price:0 was failing structured-data validators and
  // integrations are not sold as standalone free products.
  const schemaData: WithContext<SoftwareApplication> = {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: `${title} Integration`,
    description,
    url: `https://transcend.io${href}`,
    image: imageUrl,
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'Web',
    publisher: schemaOrganization,
  };

  return <RenderSEOSchema schemaData={schemaData} />;
}
